import(/* webpackMode: "eager" */ "/app/src/app/[locale]/auth/choose/page.tsx");
